import Vue from 'vue';
import Router from 'vue-router';

import config from '@/config/config';
import store from './store';
import Storage from '@/service/Storage';
import routesCode from '@/config/route/code';
import routesUser from '@/config/route/user';
import routesAntagonist from '@/config/route/antagonist';

Vue.use(Router);

let routes = routesCode;
if (config.app === 'user') {
  routes = routesUser;
} else if (config.app === 'antagonist') {
  routes = routesAntagonist;
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Hooks
// @see https://router.vuejs.org/guide/advanced/meta.html
router.beforeEach((to, from, next) => {
  const publicAccess = [
    'login',
    'register',
    'forgotPassword',
    'newPassword',
    'privacyPolicy',
  ];

  // Check login
  const token = Storage.getItem('token');
  const storeToken = store.state.token;

  if (!storeToken && token) {
    store.commit(`${config.app}/setToken`, token);
  }

  if (publicAccess.includes(to.name)) {
    return next();
  }

  if (!token) {
    return next({ name: 'login' });
  }

  // Check if user has access
  store.dispatch(`${config.app}/fetchUser`);
  return next();
});

export default router;
